import Axios from 'axios';
import header from '../auth/header';

const API_URL_V3 = process.env.API_URL + '/api/v3/'

class Corporate {
    dropdownLegalEntityIndex(params) {
        return Axios.get(API_URL_V3 + `data/legal-entity-types/`, { headers: header() });
    }

    dropdownBusinessField(params){
        return Axios.get(API_URL_V3 + `data/business-fields`, { headers: header() });
    } 

    dropdownTujuanPembukaan(params){
        return Axios.get(API_URL_V3 + `data/account-opening-purposes`, { headers: header() });
    } 

    dropdownSumberDana(params){
        return Axios.get(API_URL_V3 + `data/fund-sources`, { headers: header() });
    } 

    dropdownPerkiraanTransaksi1Tahun(params){
        return Axios.get(API_URL_V3 + `data/estimated-transaction-values?order_column=code&order_direction=asc`, { headers: header() });
    } 
    
    updateCorporateData(data){
        return Axios.post(API_URL_V3 + 'users/corporate/detail/', data, { headers: header() });
    }

    updateCorporateProfile(data){
        return Axios.post(API_URL_V3 + 'users/corporate/profile/', data, { headers: header() });
    }
    
    getCorporateDetail(params){
        return Axios.get(API_URL_V3 + 'users/corporate/detail/', { headers: header() });
    }
    
    getCorporateProfile(params){
        return Axios.get(API_URL_V3 + 'users/corporate/profile/', { headers: header() });
    }
    
    dropdownPosition(params){
        return Axios.get(API_URL_V3 + `data/positions/dropdown?order_column=name&order_direction=asc`, { headers: header() });
    }

    dropdownIdentityType(params){
        return Axios.get(API_URL_V3 + `data/identity-types?order_column=name&order_direction=asc`, { headers: header() });
    }

    dropdownResidence(params){
        return Axios.get(API_URL_V3 + `data/residence-statuses`, { headers: header() });
    }

  show(product) {
    return Axios.get(API_URL_V3 + `product/${product}`);
  }

  funderShow(product) {
    return Axios.get(API_URL_V3 + `funder-product/${product}`);
  }

  mitraShow(product) {
    return Axios.get(API_URL_V3 + `mitra-product/${product}`, { headers: header() });
  }

  orderName() {
    return Axios.get(API_URL_V3 + 'product-ordername');
  }

  store(data) {
    return Axios.post(API_URL_V3 + 'add-product', data, { headers: header() });
  }

  update(data) {
    return Axios.put(API_URL_V3 + 'update-product', data, { headers: header() });
  }

  delete(id) {
    return Axios.delete(API_URL_V3 + `delete-product/${id}`, { headers: header() });
  }

  productOnMitra(mitra) {
    return Axios.get(API_URL_V3 + `product-on-mitra/${mitra}`, { headers: header() });
  }
  
  lendingOnMitra(mitra) {
    return Axios.get(API_URL_V3 + `lending-on-mitra/${mitra}`, { headers: header() });
  }

  productPengajuan() {
    return Axios.get(API_URL_V3 + 'product-pengajuan', { headers: header() });
  }

  productClosing() {
    return Axios.get(API_URL_V3 + 'product-closing', { headers: header() });
  }

  productFilter(filter, id) {
    return Axios.get(API_URL_V3 + `product-list/filter/${filter}/${id}`);
  }

  productSorting(sort, mode) {
    return Axios.get(API_URL_V3 + `product-list/sorting/${sort}/${mode}`);
  }

  productSearch(search) {
    return Axios.get(API_URL_V3 + `product-list/search/${search}`);
  }

  changePublishStatus(data) {
    return Axios.patch(API_URL_V3 + 'change-publish-status', data,  { headers: header() })
  }

  getIsFillMitraData() {
    return Axios.get(API_URL_V3 + `getIsFillMitraData`, { headers: header() });
  }
  
  installmentSimulation(productId, downPayment, tenurePeriod) {
    return Axios.get(`${API_URL_V3}product-lending/funder/${productId}/simulation/installment`, {
      params: {
        down_payment: downPayment,
        tenure_period: tenurePeriod
      }
    });
  }

  IndexDeposito(){
    return Axios.get(API_URL_V3 + `product/funder`);
  }

  showDeposito(id){
    return Axios.get(API_URL_V3 + `product/funder/${id}?with=mitra.mitra_profile,subCategory,category,akad`);
  }
}

export default new Corporate();



// WEBPACK FOOTER //
// ./src/api/corporate/corporate.js